namespace TabAurous.Administration {
    export interface ConfigLookupRow {
        Code?: string;
        Value?: string;
        Type?: string;
    }

    export namespace ConfigLookupRow {
        export const idProperty = 'Code';
        export const nameProperty = 'Code';
        export const localTextPrefix = 'Administration.ConfigLookup';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = '*';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Code = "Code",
            Value = "Value",
            Type = "Type"
        }
    }
}
